<template>
    <el-tabs
        v-model="logTab"
        type="card"
        class="education-content tabs-full"
        @tab-click="togglelogTab"
    >
        <el-tab-pane label="登录日志" name="loginlog">
            <Loginlog ref="loginlog" />
        </el-tab-pane>
        <el-tab-pane label="异常日志" name="loginExceptionMessage">
            <LoginExceptionMessage ref="loginExceptionMessage" />
        </el-tab-pane>
        <el-tab-pane label="操作日志" name="operationLog">
            <OperationLog ref="operationLog" />
        </el-tab-pane>
    </el-tabs>
</template>

<script>
import Loginlog from '../../components/admin/LogManagement/Loginlog.vue';
import LoginExceptionMessage from '../../components/admin/LogManagement/LoginExceptionMessage.vue';
import OperationLog from '../../components/admin/LogManagement/OperationLog.vue';

export default {
    data() {
        return {
            logTab: 'loginlog',
        };
    },
    components: {
        Loginlog,
        LoginExceptionMessage,
        OperationLog,
    },
    methods: {
        togglelogTab(tab) {
            if (tab.name === 'loginlog') {
                this.$refs.loginlog.getSchoolList();
            } else if (tab.name === 'loginExceptionMessage') {
                this.$refs.loginExceptionMessage.getSchoolAdminList();
            } else if (tab.name === 'operationLog') {
                this.$refs.operationLog.getTrainAdminList();
            }
        },
    },
};
</script>

<style scoped lang="scss">
.education-content {
    height: 100%;
}
</style>
